import styled from 'styled-components';
import { Button } from '@components/Button';
import { themeMediaQuery } from '@utils/styledTheme.util';

export const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  width: 344px;
  height: 48px;
  font-size: 15px;
  line-height: 24px;
  ${themeMediaQuery('sm')} {
    width: 600px;
    height: 72px;
    font-size: 24px;
    line-height: 36px;
  }
`;
